import type { MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  CertifyPartnerCreditInput,
  CreatePartnerCreditVersionInput,
  PartnerCreditApproval,
  PartnerCreditCertification,
  PartnerCreditConfiguration,
  PartnerCreditInput,
  PartnerCreditPreview,
  PartnerCreditStatusInput,
  PartnerCreditVersion,
} from './types';

export interface PartnerCreditRepository {
  get(partnerId: string, signal: AbortSignal): Promise<PartnerCreditConfiguration>;
  listVersions(partnerId: string, signal: AbortSignal): Promise<readonly PartnerCreditVersion[]>;
  preview(partnerId: string, input: PartnerCreditInput): Promise<PartnerCreditPreview>;
  createVersion(
    partnerId: string,
    input: CreatePartnerCreditVersionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<PartnerCreditApproval>>;
  certify(
    partnerId: string,
    input: CertifyPartnerCreditInput,
  ): Promise<MutationResult<PartnerCreditCertification>>;
  changeStatus(
    partnerId: string,
    input: PartnerCreditStatusInput,
  ): Promise<MutationResult<PartnerCreditConfiguration>>;
}

export const partnerCreditRepositoryToken =
  createRepositoryToken<PartnerCreditRepository>('partnerCredit');
